import {MdKeyboardArrowLeft as LeftArrow} from 'react-icons/md'
import {MdSort} from 'react-icons/md'
import {useEffect} from '@hooks/useEffect'
import useWidth from '@hooks/useWidth'
import {useTranslation} from 'next-i18next'

import useProductFiltersContext from './hooks/useProductFiltersContext'
import UsePriceFilters from './usePriceFilters'
import UseProductFilters from './useProductFilters'

import styles from './styles.module.css'

export default function ProductFilters({setOpenFilters}) {
  const {
    filterTypes,
    setFilterTypes,
    setProductFilters,
    productFilters,
    getAllFilters,
    setPriceFilters,
    priceFilters
  } = useProductFiltersContext()

  useEffect(() => {
    setFilterTypes(filterTypes)
    setProductFilters(productFilters)
  }, [productFilters])

  const {t} = useTranslation('website', {keyPrefix: 'order.products.productsContent.filters'})
  const width = useWidth()
  const isMobile = width <= 768

  const containerStyles = isMobile && styles.containerMobile
  const headerStyles = isMobile ? styles.headerMobile : styles.header

  const returnAllFilters = () => {
    const {categoryFilterTypes, generatedPriceFilters} = getAllFilters()
    setFilterTypes(categoryFilterTypes)
    setPriceFilters(generatedPriceFilters)
  }

  if (Object.keys(filterTypes).length == 0) {
    return null
  }

  const cleanFilters = () => {
    setProductFilters([])
    setPriceFilters([])
    returnAllFilters()
  }

  const backToMenu = () => {
    setOpenFilters(false)
    cleanFilters()
  }

  return (
    <div>
      <div className={headerStyles}>
        {isMobile && (
          <span onClick={backToMenu}>
            <LeftArrow size="22" />
          </span>
        )}
        <span className={styles.titleFilter}>
          {isMobile && <MdSort size="18" />}
          {t('labelFilters')}
        </span>
        <button onClick={cleanFilters}>{t('LabelCleanFilters')}</button>
      </div>
      <div className={containerStyles}>
        <UseProductFilters />
        <UsePriceFilters priceFilters={priceFilters} setPriceFilters={setPriceFilters} />
      </div>
      {isMobile && (
        <div className={styles.containerButton}>
          <button className={styles.buttonFilter} onClick={() => setOpenFilters(false)}>
            {t('LabelApplyFilters')}
          </button>
        </div>
      )}
    </div>
  )
}
